var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMembersWorkingOutOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_43897)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.69141,
    y: 9.22559,
    width: 3.77073,
    height: 10.3695,
    rx: 1,
    transform: "rotate(-30 1.69141 9.22559)",
    stroke: "#878786",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65625,
    y: 13.0889,
    width: 2.82805,
    height: 4.71341,
    rx: 1,
    transform: "rotate(-30 0.65625 13.0889)",
    stroke: "#878786",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.77073,
    height: 10.3695,
    rx: 1,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 13.1211 2.62695)",
    stroke: "#878786",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.82804,
    height: 4.71341,
    rx: 1,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 16.9844 3.66211)",
    stroke: "#878786",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08203 12.083L12.9154 8.74968",
    stroke: "#878786",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_43897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersWorkingOutOff);
export default __webpack_public_path__ + "static/media/members-working-out-off.46c697dbfe335a6563a26b7ce8abade9.svg";
export { ForwardRef as ReactComponent };